import React from 'react';
import {unwrapResult} from '@reduxjs/toolkit';
import {useDispatch, useSelector} from 'react-redux';
import {UiQuestionnaireLayout, Col, UiText, UiDivider, UiButton, Row, UiSimpleGrid} from '~/components/elements';
import {METHOD_KEYS, FERTILITY_TEST_KEYS, YES_OPTION} from '~/constants/medical-questionnaires';
import {useInput, useRequestState} from '~/hooks';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {addQuestionnaire, bookAppointment} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {redirectInIframe} from '~/utils/helpers';
import {requestOK} from '~/utils/thunk-api';
import {spacing} from '~/utils/theme/spacing';

const Questionnaire4Screen = () => {
  const dispatch: AppDispatch = useDispatch();
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === FERTILITY_TEST_KEYS.ON_BIRTH_CONTROL);
  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectData[FERTILITY_TEST_KEYS.ON_BIRTH_CONTROL]?.data,
  );
  const {inputs, setInputs} = useInput({
    selectedOption: currentAnswer?.selectedOption || '',
  });

  const onClickSubmit = async () => {
    dispatch(
      setQuestionnaireAnswer({
        key: FERTILITY_TEST_KEYS.ON_BIRTH_CONTROL,
        index: questionnaire?.index || '',
        data: inputs,
      }),
    );
    dispatch(setNextQuestionnaire({value: FERTILITY_TEST_KEYS.APPOINTMENT_PREFERENCES}));
  };

  return (
    <UiQuestionnaireLayout
      backIcon
      handleOnNext={onClickSubmit}
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      disableNext={!inputs?.selectedOption}
    >
      <Col align="center" textAlign="center">
        <UiText variant="mdqTitle" my={10}>
          {questionnaire?.questions?.default}
        </UiText>
        <Row w="100%">
          {questionnaire?.options?.map((value, index) => (
            <UiButton
              key={`${value.label}-${value.value}`}
              title={value.label}
              variant={inputs?.selectedOption === value?.value ? 'solid' : 'toggle'}
              onClick={() => setInputs({selectedOption: value?.value})}
              height="35px"
              w="100%"
              mx={1}
            />
          ))}
        </Row>
        {inputs?.selectedOption === YES_OPTION && (
          <Col px={2}>
            <UiText mt={spacing.medium} color="liteOuter">
              {questionnaire?.questions?.sub}
            </UiText>
            <UiText mt={spacing.medium} color="liteOuter">
              {questionnaire?.questions?.sub1}
            </UiText>
          </Col>
        )}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire4Screen;
